module.exports = __webpack_public_path__ + "img/resource-zn.1675735b.png";